<template>
  <div class="bg5">
    <div class="contact-form">
      <h1>Welcome to Inquire</h1>
      <p>We will carefully review your message and arrange for the most suitable engineer to contact you.</p>
      <form>
        <div class="form-row">
          <input type="text" placeholder="Name"  v-model="formData.name" />
          <input type="text" placeholder="Phone" v-model="formData.phone" />
        </div>
        <div class="form-row">
          <input style="width: 100%;" type="email" placeholder="Email" v-model="formData.email" />
        </div>
        <div class="form-row">
          <textarea placeholder="Message" rows="4" v-model="formData.content"></textarea>
        </div>
        <div class="button-container">
          <button type="submit" @click="handleSubmit">SUBMIT</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { getContactUs } from "@/api/api";
import { Message } from "element-ui";
export default {
  data() {
    return {
      formData: {
        name: "",
        phone: "",
        email: "",
        content: "",
      },
    };
  },
  methods: {
    handleSubmit(event) {      
      event.preventDefault();
      // 姓名校验：不能为空
      if (!this.formData.name) {
        Message.error('Name cannot be empty');
        return;
      }
      // 电话校验：不能为空，且为11位数字
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!this.formData.phone) {
        Message.error('Phone cannot be empty');
        return;
      } else if (!phoneRegex.test(this.formData.phone)) {
        Message.error('Please enter a valid 11 digit phone number');
        return;
      }
      // 邮箱校验：不能为空，且符合邮箱格式
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!this.formData.email) {
        Message.error('Email cannot be empty');
        return;
      } else if (!emailRegex.test(this.formData.email)) {
        Message.error('Please enter a valid email address');
        return;
      }
      // 留言校验：不能为空
      if (!this.formData.content) {
        Message.error('Message cannot be empty');
        return;
      }
      let postData = {
        name: this.formData.name,
        phone: this.formData.phone,
        email: this.formData.email,
        content: this.formData.content,
      };
      getContactUs(postData).then((res) => {
        if (res.code == 200) {
          Message.success(res.message);
          this.formData = {};
        } else {
          Message.error(res.message);
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.form-row {
  margin-bottom: 8px;
  background-color: #000000;
  display: flex;
  justify-content: center;
}
.form-row select::placeholder {
  color: #ffffff;
  font-size: 8px;
}
.form-row input,
.form-row select {
  border: 1px solid #666;
  background-color: #24272a;
  color: #fff;
  border-radius: 2px;
  width: 50%;
  padding: 5px;
  margin: 2px;
  font-size: 12px;
}
.form-row input::placeholder {
  color: #ffffff;
  font-size: 12px;
}

.form-row textarea::placeholder {
  color: #ffffff;
  font-size: 12px;
}


.form-row textarea {
  border: 1px solid #666;
  background-color: #24272a;
  color: #fff;
  border-radius: 2px;
  width: 100%;
  padding: 5px;
}

.button-container button {
  padding: 5px 30px;
  background-color: #2a82e4;
  color: #fff;
  border: none;
  border-radius: 20px;
  cursor: pointer;
}
.button-container {
  display: flex;
  justify-content: center;
  padding: 20px 0;
  /* 水平居中 */
}
.contact-form h1 {
  font-size: 26px;
  color: white;
  margin-bottom: 20px;
  text-align: center;
}
.contact-form p {
  font-size: 12px;
  color: white;
  margin-bottom: 20px;
  text-align: center;
  line-height: 20px;
}
.bg5 {
  background: black;
  padding: 20px 43px;
}
@media screen and (min-width: 768px){
  .form-row {
  margin-bottom: 8px;
  background-color: #000000;
  display: flex;
  justify-content: center;
}
.form-row select::placeholder {
  color: #ffffff;
  font-size: 18px;
}
.form-row input,
.form-row select {
  border: 1px solid #666;
  background-color: #24272a;
  color: #fff;
  border-radius: 2px;
  width: 50%;
  padding: 20px;
  margin: 2px;
  font-size: 18px;
}
.form-row input::placeholder {
  color: #ffffff;
  font-size: 18px;
}

.form-row textarea::placeholder {
  color: #ffffff;
  font-size: 18px;
}


.form-row textarea {
  border: 1px solid #666;
  background-color: #24272a;
  color: #fff;
  border-radius: 2px;
  width: 100%;
  padding: 20px;
}

.button-container button {
  padding: 5px 30px;
  background-color: #2a82e4;
  color: #fff;
  border: none;
  border-radius: 30px;
  width: 150px;
  font-size: 18px;
  height: 50px;
  cursor: pointer;
}
.button-container {
  display: flex;
  justify-content: center;
  padding: 20px 0;
  /* 水平居中 */
}
.contact-form h1 {
  font-size: 40px;
  color: white;
  margin-bottom: 20px;
  text-align: center;
}
.contact-form p {
  font-size: 18px;
  color: white;
  margin-bottom: 20px;
  text-align: center;
  line-height: 20px;
}
.bg5 {
  background: black;
  padding: 20px 43px;
}
}
</style>